import type { MessageDescriptor } from '@atlassian/jira-intl';
import messages from './messages';

export const ALL = 'ALL';
export const MAPPED = 'MAPPED';
export const UNMAPPED = 'UNMAPPED';

export type Filter = typeof ALL | typeof MAPPED | typeof UNMAPPED;

export const availableFilters: Filter[] = [ALL, MAPPED, UNMAPPED];

export const filterMessages: Record<Filter, MessageDescriptor> = {
	ALL: messages.allFields,
	MAPPED: messages.mappedFields,
	UNMAPPED: messages.unmappedFields,
};
